import styled, { css, keyframes } from 'styled-components';

export const riseIn = keyframes`
  from {
    transform: translateY(0.75rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

/**
 * Circular native-speaker / badge frame used by checkpoint and EOS celebrations.
 */
export const CircleStage = styled.div(
  ({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1;
    border-radius: ${theme.bo.elliptical};
    border: ${theme.sz.s2} solid ${theme.co.neutral99};
    background: ${theme.co.primary30};
    overflow: hidden;
    box-shadow: 0 ${theme.sz.s2} ${theme.sz.s5} rgba(41, 55, 73, 0.18);
  `,
);

export const Caption = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s1};
  `,
);

export const Phrase = styled.p(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.s};
    color: ${theme.co.secondary20};
    margin: 0;
  `,
);

export const Translation = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.secondary50};
    margin: 0;
  `,
);
